module.exports = __webpack_public_path__ + "static/img/KOHH.f35c236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/KOHH.jpg
// module id = +0Hj
// module chunks = 1